import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { elementRulesStateToProps, get } from 'ctm-util-functions';
import { TextTemplate, getSelectedValues, SimpleFlexbox } from 'ctm-components';
import styles from './custom_field_row.css';

/**
 * A TextTemplate wrapper with styles to fit in a fieldRow
 * @param {Object} props - properties to render the component
 * @param {Object} props.schema - element's schema
 * @param {Object} rules - The resolved rules for the element
 * @returns {Node} - A TextTemplate component with simples scripting styles
 */
const _ContentFieldRow = ({ schema, rules, selectedValues }) => {
    if (!get(rules, 'visibility.result', true)) {
        return null;
    }
    const { label, tagName, innerHTML, className, container } = schema;
    const combinedClassNames = classNames(styles[tagName], styles.root, styles[className]);
    return (
        <SimpleFlexbox {...container}>
            <TextTemplate
                className={combinedClassNames}
                innerHTML={innerHTML}
                label={label}
                tagName={tagName}
                selectedValues={selectedValues} />
        </SimpleFlexbox>
    );
};

_ContentFieldRow.propTypes = {
    schema: PropTypes.object.isRequired,
    rules: PropTypes.object,
    selectedValues: PropTypes.object
};

/**
 * Map the element's resolved rules to props
 * @param {Immutable.Map} state - Redux store state.
 * @param {Object} props - properties to render the component
 * @returns {Object} props with added rules
 */
const mapStateToProps = (state, props) => {
    return {
        rules: elementRulesStateToProps()(state, props).rules,
        selectedValues: getSelectedValues(state, props)
    };
};
const ContentFieldRow = connect(mapStateToProps)(_ContentFieldRow);
export { ContentFieldRow, _ContentFieldRow };
